module.exports = __webpack_public_path__ + "da90262ee56a04f207a7fa623bfc8a46.png";